import { render } from "./ProxyNftMintAccountComponent.vue?vue&type=template&id=5bb79313&scoped=true"
import script from "./ProxyNftMintAccountComponent.vue?vue&type=script&lang=js"
export * from "./ProxyNftMintAccountComponent.vue?vue&type=script&lang=js"

import "./ProxyNftMintAccountComponent.vue?vue&type=style&index=0&id=5bb79313&lang=css"
import "./ProxyNftMintAccountComponent.vue?vue&type=style&index=1&id=5bb79313&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bb79313"]])

export default __exports__